import { CSSProperties } from "react";
import Colors from "modules/Colors";
import Icon from "elements/Icon";
import { clsx, styx } from "modules/Utils";
import { Tag } from "elements/TagSymphony";

interface TagSymphonyProps {
    className: string;
    style?: CSSProperties;
    color?: 'purple' | 'green' | 'yellow' | 'red' | 'grey';
    icon?: string;
    children?: React.ReactNode;
    onClick?: (tag: Tag) => void;
    title?: string;
    id?: string | number;
    tag?: Tag | null;
    isHashTag?: boolean;
    onAdd?: (tag: Tag) => void;
    onRemove?: (tag: Tag) => void;
}

const TagSymphony = ({
    className,
    style,
    color = 'purple',
    icon,
    children,
    onClick,
    title: titleProp = '',
    id: idProp = '',
    tag: tagProp = null,
    isHashTag = false,
    onAdd,
    onRemove,
}: TagSymphonyProps) => {
    const iconComponent = icon ? <Icon className="tagSymphonyIcon" icon={icon} size={16} color={color} /> : null;

    let tag = tagProp || null;
    if (!tag) {
        tag = {
            title: titleProp,
            id: idProp,
        }
    }

    const {
        title,
        id,
    } = tag;

    const handleClick = () => {
        if (onClick && tag) {
            onClick(tag);
        }
    }

    const handleAddOrRemoveClick = () => {
        if (onAdd && tag) {
            onAdd(tag)
        } else if (onRemove && tag) {
            onRemove(tag)
        }
    }

    const addOrRemoveButton = (onAdd || onRemove) && (
        <div
            className="tagSymphonyCloseButton"
            style={sty.tagSymphonyAddOrRemoveButton}
            onClick={handleAddOrRemoveClick}
        >
            {onAdd ? '+' : '×'}
        </div>
    )

    if (!tagProp && !title && !id) {
        return null;
    }

    return (
        <div
            className={clsx(
                'tagSymphonyComponent',
                className,
                onClick ? 'clickable' : '',
                `tag-${color}`
            )}
            onClick={handleClick}
            style={styx(
                sty.tagSymphonyComponent,
                onClick ? { cursor: 'pointer' } : null,
                sty[`tag_${color}`],
                style
            )}
        >
            {children ?
                <>
                    {iconComponent}
                    {isHashTag ? '#' : ''}
                    {children}
                    {addOrRemoveButton &&
                        addOrRemoveButton
                    }
                </>
                :
                <>
                    {iconComponent}
                    {isHashTag ? '#' : ''}
                    {title}
                    {addOrRemoveButton &&
                        addOrRemoveButton
                    }
                </>
            }
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    tagSymphonyComponent: {
        backgroundColor: Colors.purpleLightest,
        color: Colors.purple,
        borderWidth: 1,
        borderColor: Colors.purple,
        borderStyle: 'solid',
        borderRadius: 1000,
        fontSize: 12,
        height: 30,
        paddingLeft: 16,
        paddingRight: 16,
        width: 'fit-content',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexShrink: 0,
        gap: 4,
    },
    tag_purple: {
        color: Colors.purple,
        borderColor: Colors.purple,
        backgroundColor: Colors.purpleTransparent,
    },
    tag_green: {
        color: Colors.green,
        borderColor: Colors.green,
        backgroundColor: Colors.greenTransparent,
    },
    tag_yellow: {
        color: Colors.yellow,
        borderColor: Colors.yellow,
        backgroundColor: Colors.yellowTransparent,
    },
    tag_red: {
        color: Colors.red,
        borderColor: Colors.red,
        backgroundColor: Colors.redTransparent,
    },
    tag_grey: {
        color: Colors.greyDark,
        borderColor: Colors.greyLight,
        backgroundColor: Colors.greyLight,
    },
    tagSymphonyAddOrRemoveButton: {
        fontSize: 16,
        cursor: 'pointer',
        transform: 'translateY(-1px)',
    }
}

export default TagSymphony;